import * as CustomOrderAction from './constants';

const Customorders = {};

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 10,
  sort: { field: 'refNo', order: 'descending' },
  status: '',
  totalRecord: 0,
  totalPage: 0
};

const CustomorderState = {
  Customorders: Customorders,
  CustomorderProfile: null,
  CustomordersList: {
    params: { ...defaultParams }
  },
  CustomorderAttachments: [],
  IsRedirectToEdit: {
    isRedirect: false,
    refNo: null
  },
  DefaultConfigList:[],
  DefaultConfigTradeList:[]
};

export default function CustomorderStore(state = CustomorderState, action) {
  switch (action.type) {
     case CustomOrderAction.GET_DEFAULT_CONFIG_FOR_DROPDOWN_SUCCESS:
      return{
        ...state,
        DefaultConfigList:action.data
      }; 
      case CustomOrderAction.SELECT_TRADE_SUCCESS:
        return{
          ...state,
          DefaultConfigTradeList:action.data
        };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/DefaultConfig/reducers.js